export const stringToBase64 = (str: string): string => {
    return Buffer.from(str).toString("base64");
};
export const base64ToString = (base64: string): string => {
    return Buffer.from(base64, "base64").toString("utf-8");
};

export function base64ToBlobUrl(base64: string): Promise<string> {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.src = base64;

        img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext("2d");

            if (!ctx) {
                return reject(new Error("Canvas context not available"));
            }

            ctx.drawImage(img, 0, 0);
            canvas.toBlob((blob) => {
                if (blob) {
                    resolve(URL.createObjectURL(blob));
                } else {
                    reject(new Error("Failed to convert image to Blob"));
                }
            });
        };

        img.onerror = (err) => reject(err);
    });
}
